import t from "../../theme";

export const useGetProgressBarStyles = ({ progressBar }) => {
  return {
    container: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 6,
    },
    track: {
      width: "100%",
      height: 10,
      borderRadius: 20,
      background:
        "linear-gradient(180deg, rgba(46,125,50,0.08) 0%, rgba(46,125,50,0.04) 100%)",
      border: "1px solid rgba(46, 125, 50, 0.1)",
      position: "relative",
      overflow: "hidden",
      boxShadow: "inset 0 1px 3px rgba(0,0,0,0.06)",
    },
    fill: {
      position: "absolute",
      top: 0,
      left: 0,
      width: `${progressBar}%`,
      height: "100%",
      borderRadius: 20,
      background:
        "linear-gradient(90deg, #43a047 0%, #66bb6a 40%, #81c784 70%, #66bb6a 100%)",
      boxShadow:
        "0 0 8px rgba(46, 125, 50, 0.4), inset 0 1px 0 rgba(255,255,255,0.3)",
      transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    shimmer: {
      position: "absolute",
      top: 0,
      left: 0,
      width: `${progressBar}%`,
      height: "100%",
      borderRadius: 20,
      background:
        "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.35) 50%, transparent 100%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 2s infinite linear",
      pointerEvents: "none",
      "@keyframes shimmer": {
        "0%": { backgroundPosition: "200% 0" },
        "100%": { backgroundPosition: "-200% 0" },
      },
    },
    milestone: {
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.6)",
      border: "1px solid rgba(46, 125, 50, 0.15)",
      zIndex: 2,
      transition: t.transition.smooth,
    },
    milestoneReached: {
      background: "#fff",
      border: "1.5px solid #43a047",
      boxShadow: "0 0 4px rgba(46, 125, 50, 0.4)",
    },
    labels: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    currentPoints: {
      fontSize: "0.72rem",
      fontWeight: 600,
      color: "#43a047",
      background: "rgba(46, 125, 50, 0.06)",
      padding: "1px 8px",
      borderRadius: t.radius.pill,
      border: "1px solid rgba(46, 125, 50, 0.12)",
    },
    maxPoints: {
      fontSize: "0.72rem",
      fontWeight: 500,
      color: t.text.muted,
    },
  };
};
